import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>

                    <ListGroup.Item as={Link} action to="/admin-staff" className={`p-3 mb-3 ${activeIndex==0 ? " active" : ""}`}>
                        <i className="fas fa-chevron-circle-right me-3"></i>
                        Staff
                    </ListGroup.Item>

                    <ListGroup>


                        <ListGroup.Item as={Link} action to="/chemical-engineering-department" className={`p-3 ${activeIndex==1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Chemical
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/chemistry-department" className={`p-3 ${activeIndex==2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Chemistry
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/civilengineering-department" className={`p-3 ${activeIndex==3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Civil
                        </ListGroup.Item>
            

                        <ListGroup.Item as={Link} action to="/computer-science-engineering-department" className={`p-3 ${activeIndex==4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Computer Science
                        </ListGroup.Item>
                        
                        <ListGroup.Item as={Link} action to="/electrical-engineering-department" className={`p-3 ${activeIndex==5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Electrical
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/humanities-and-social-sciences-department" className={`p-3 ${activeIndex==6 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Humanities and Social Sciences
                        </ListGroup.Item>


                    
                        <ListGroup.Item as={Link} action to="/mathematics-department" className={`p-3 ${activeIndex==7 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Mathematics & Statistics
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/mechanical-engineering-department" className={`p-3 ${activeIndex==8 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Mechanical
                        </ListGroup.Item>


                        <ListGroup.Item as={Link} action to="/physics-department" className={`p-3 ${activeIndex==9 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Physics
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/others" className={`p-3 ${activeIndex==10 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Other Guest Faculty
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/resourcesacademics" className={`p-3 ${activeIndex==11 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Resources
                        </ListGroup.Item>



                    </ListGroup>
                </Col>
                {/* <Col sm={8}>
          <Tab.Content>
            <Tab.Pane eventKey="#link1">Tab pane content 1</Tab.Pane>
            <Tab.Pane eventKey="#link2">Tab pane content 2</Tab.Pane>
          </Tab.Content>
        </Col> */}
            </Row>
        </Tab.Container>
    );
}

export default Main;